import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import colors from "../../../theme/color/ColorTheme";
import ScrollToTop from "../../../hooks/scrollToTop";

const DesktopWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 110vh;

  &::-webkit-scrollbar {
    display: none;
  }

  img {
    width: 100%;
    display: block;
  }

  @media (max-width: 950px) {
    display: none;
  }
`;

const MobileWrapper = styled.div`
  width: 100%;
  display: none;
  position: relative;

  @media (max-width: 950px) {
    display: block;
  }

  img {
    width: 100%;
    border-radius: 4px;
    display: block;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 18px !important;
    left: 18px !important;
    right: auto !important;
    width: auto !important;
    display: inline-flex !important;
    text-align: left;
    background-color: white;
    padding: 4px 8px;
    border-radius: 8px;
  }

  .swiper-pagination-bullet {
    width: 4px;
    height: 1px;
    border-radius: 0px;
    margin: 0 2px !important;
    background: ${colors.border};
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    width: 15px;
    background: ${colors.maroon};
  }
`;

function ProductImages({ images }) {
  return (
    <>
      <ScrollToTop />
      {/* Desktop scroll */}
      <DesktopWrapper>
        {images.map((src, index) => (
          <img key={index} src={src} alt="product" />
        ))}
      </DesktopWrapper>

      {/* Mobile swipe */}
      <MobileWrapper>
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={12}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img src={src} alt="product" />
            </SwiperSlide>
          ))}
        </Swiper>
      </MobileWrapper>
    </>
  );
}

export default ProductImages;
